import { useAuth } from "@shared/hooks/useAuth";
import { getThemeColorScheme, ThemeColorScheme } from "@avenue-8/sidekick-ui";
import { useAuthStore } from "@store/auth.store";
import { ToastContainer as ReactToastifyToastContainer } from "react-toastify";

type Props = {
  theme?: ThemeColorScheme;
};

export const ToastContainer = (props: Props) => {
  const { theme } = props;
  const { isAuthenticated } = useAuth();
  const userPreferencesTheme = useAuthStore((state) => state.preferences.theme);

  return (
    <ReactToastifyToastContainer
      position="top-center"
      autoClose={5000}
      hideProgressBar
      pauseOnHover
      theme={
        isAuthenticated
          ? getThemeColorScheme(theme ?? userPreferencesTheme)
          : "light"
      }
    />
  );
};
